import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { supabase } from '../supabase';
import { getBadgesUtilisateur } from '../badges';

export default function ProfilPublic() {
  const navigate = useNavigate();
  const { prenom } = useParams();
  const [profil, setProfil] = useState(null);
  const [enfants, setEnfants] = useState([]);
  const [badges, setBadges] = useState([]);
  const [activites, setActivites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchProfil(); }, [prenom]);

  const fetchProfil = async () => {
    setLoading(true);
    const { data: users } = await supabase.from('users').select('*').ilike('prenom', prenom).limit(1);
    if (!users || users.length === 0) { setLoading(false); return; }
    const user = users[0];
    setProfil(user);
    const [{ data: enfantsData }, badgesData, { data: activitesData }] = await Promise.all([
      supabase.from('enfants').select('*').eq('user_id', user.id),
      getBadgesUtilisateur(user.id),
      supabase.from('activites').select('*').eq('user_id', user.id).gte('date', new Date().toISOString().split('T')[0]).order('date', { ascending: true }).limit(5),
    ]);
    if (enfantsData) setEnfants(enfantsData);
    setBadges(badgesData || []);
    if (activitesData) setActivites(activitesData);
    setLoading(false);
  };

  const handlePartager = async () => {
    const url = `https://wooki.app/famille/${prenom}`;
    try {
      if (navigator.share) await navigator.share({ title: `${profil.prenom} sur Wooki`, url });
      else { await navigator.clipboard.writeText(url); alert('Lien copié !'); }
    } catch (e) {}
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FAFAF7' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: 12 }}>🌿</div>
        <div style={{ fontFamily: 'Fredoka One, cursive', color: '#3D9A6A' }}>Chargement...</div>
      </div>
    </div>
  );

  if (!profil) return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#FAFAF7' }}>
      <div style={{ textAlign: 'center', padding: '0 24px' }}>
        <div style={{ fontSize: '3rem', marginBottom: 12 }}>😕</div>
        <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.3rem', color: '#1C2B1E', marginBottom: 8 }}>Famille introuvable</div>
        <button onClick={() => navigate('/feed')} style={{ padding: '12px 24px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 800, cursor: 'pointer' }}>← Retour</button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight: '100vh', background: '#FAFAF7', paddingBottom: 100 }}>
      <style>{`@keyframes badgePop{0%{transform:scale(0);opacity:0}70%{transform:scale(1.2)}100%{transform:scale(1);opacity:1}}`}</style>

      {/* HERO */}
      <div style={{ background: 'linear-gradient(160deg, #1C2B1E, #2D7A52)', padding: '48px 24px 60px', position: 'relative', overflow: 'hidden', textAlign: 'center' }}>
        <div style={{ position: 'absolute', width: 200, height: 200, borderRadius: '50%', background: 'radial-gradient(circle, #52C289, transparent)', opacity: 0.2, top: -60, right: -40 }} />
        <button onClick={() => navigate(-1)} style={{ position: 'absolute', top: 16, left: 20, background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 100, padding: '8px 14px', color: 'white', fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.82rem', cursor: 'pointer' }}>← Retour</button>
        <div onClick={() => navigate('/')} style={{ position: 'absolute', top: 18, right: 20, fontFamily: 'Fredoka One, cursive', fontSize: '1.2rem', cursor: 'pointer' }}>
          <span style={{ color: '#52C289' }}>Woo</span><span style={{ color: '#FF7043' }}>ki</span>
        </div>
        <div style={{ width: 96, height: 96, borderRadius: '50%', overflow: 'hidden', border: '3px solid rgba(255,255,255,0.3)', margin: '0 auto 16px', background: '#EDF7F1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {profil.avatar_url ? <img src={profil.avatar_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <span style={{ fontSize: '2.8rem' }}>👤</span>}
        </div>
        <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.8rem', color: 'white', marginBottom: 8 }}>La famille {profil.prenom}</div>
        {enfants.length > 0 && (
          <div style={{ fontSize: '0.85rem', color: 'rgba(255,255,255,0.7)', marginBottom: 16 }}>
            🧒 {enfants.map(e => `${e.prenom} (${e.age} ans)`).join(' · ')}
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
          <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: 14, padding: '10px 20px', textAlign: 'center' }}>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.4rem', color: '#52C289' }}>{activites.length}</div>
            <div style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: 700 }}>activités</div>
          </div>
          <div style={{ background: 'rgba(255,255,255,0.12)', borderRadius: 14, padding: '10px 20px', textAlign: 'center' }}>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.4rem', color: '#FFB300' }}>{badges.length}</div>
            <div style={{ fontSize: '0.65rem', color: 'rgba(255,255,255,0.6)', fontWeight: 700 }}>badges</div>
          </div>
        </div>
      </div>

      <div style={{ padding: '20px' }}>
        {badges.length > 0 && (
          <div style={{ background: 'white', borderRadius: 24, padding: '16px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 14 }}>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E', marginBottom: 14 }}>🏅 Badges</div>
            <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
              {badges.map((b, i) => (
                <div key={i} style={{ textAlign: 'center', animation: `badgePop 0.4s ease ${i * 0.1}s both` }}>
                  <div style={{ width: 52, height: 52, borderRadius: 16, background: '#EDF7F1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.6rem', marginBottom: 4 }}>{b.emoji}</div>
                  <div style={{ fontSize: '0.62rem', color: '#4A6355', fontWeight: 700, maxWidth: 60, lineHeight: 1.3 }}>{b.label}</div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activites.length > 0 && (
          <div style={{ background: 'white', borderRadius: 24, padding: '16px', boxShadow: '0 4px 20px rgba(28,43,30,0.07)', marginBottom: 14 }}>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E', marginBottom: 14 }}>🌿 Prochaines sorties</div>
            {activites.map((a, i) => (
              <div key={a.id} onClick={() => navigate(`/detail/${a.id}`)} style={{ display: 'flex', gap: 12, alignItems: 'center', padding: '10px 0', borderBottom: i < activites.length - 1 ? '1px solid #F3F4F2' : 'none', cursor: 'pointer' }}>
                <div style={{ width: 44, height: 44, borderRadius: 14, background: '#EDF7F1', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.3rem', flexShrink: 0 }}>{a.emoji}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '0.9rem', color: '#1C2B1E' }}>{a.titre}</div>
                  <div style={{ fontSize: '0.72rem', color: '#8A9E8D' }}>{new Date(a.date).toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })} · {a.lieu?.split(',')[0]}</div>
                </div>
                <div style={{ color: '#3D9A6A', fontSize: '0.8rem' }}>→</div>
              </div>
            ))}
          </div>
        )}

        {activites.length === 0 && badges.length === 0 && (
          <div style={{ textAlign: 'center', padding: '40px 0' }}>
            <div style={{ fontSize: '3rem', marginBottom: 12 }}>🌱</div>
            <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1rem', color: '#1C2B1E', marginBottom: 8 }}>Pas encore d'activités</div>
            <div style={{ fontSize: '0.85rem', color: '#8A9E8D' }}>Cette famille n'a pas encore créé de sortie !</div>
          </div>
        )}

        <div style={{ background: 'linear-gradient(135deg, #1C2B1E, #2D7A52)', borderRadius: 24, padding: '20px', textAlign: 'center' }}>
          <div style={{ fontFamily: 'Fredoka One, cursive', fontSize: '1.1rem', color: 'white', marginBottom: 8 }}>Rejoins {profil.prenom} sur Wooki ! 🌿</div>
          <div style={{ fontSize: '0.82rem', color: 'rgba(255,255,255,0.7)', marginBottom: 16, lineHeight: 1.5 }}>Trouve des sorties en plein air pour tes enfants. Gratuit !</div>
          <button onClick={() => navigate('/inscription')} style={{ width: '100%', padding: '15px', background: '#3D9A6A', color: 'white', border: 'none', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 900, fontSize: '0.95rem', cursor: 'pointer', marginBottom: 10, boxShadow: '0 6px 20px rgba(61,154,106,0.4)' }}>
            🌿 Je rejoins Wooki !
          </button>
          <button onClick={handlePartager} style={{ width: '100%', padding: '12px', background: 'transparent', color: 'rgba(255,255,255,0.7)', border: '1.5px solid rgba(255,255,255,0.2)', borderRadius: 100, fontFamily: 'Nunito, sans-serif', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer' }}>
            ↗ Partager ce profil
          </button>
        </div>
      </div>
    </div>
  );
}